export enum FileStatus {
  ERROR = 0,
  SUCCESS = 1,
  UPLOADING = 2
}
